export const TYPES =[
    {
        id: 1,
        type: 'Open Bets'
    },
    {
        id: 2,
        type: 'Settled Bets'
    },
    {
        id: 3,
        type: 'Statement'
    },
    {
        id: 4,
        type: 'Win & Loss'
    }

]

export const GAME_TYPES = [
    {
        id: 1,
        type: 'Sports'
    },
    {
        id: 2,
        type: 'Games'
    }
]

export const SPORTS_SUB_TYPES = 
[
    {
        id:'ALL',
        type:'All'
    },
    {
        id:4,
        type:'Cricket'
    },
    // {
    //     id:1000,
    //     type:'Virtual Sports'
    // },
    {
        id:1,
        type:'Soccer'
    },
    {
        id:2,
        type:'Tennis'
    },
    // {
    //     id:502,
    //     type:'Assembly Ellection'
    // },
    // {
    //     id:506,
    //     type:'PSL Winner'
    // },
    // {
    //     id:507,
    //     type:'IPL Winner'
    // },
    // {
    //     id:509,
    //     type:'Kabaddi'
    // },
    // {
    //     id:513,
    //     type:'BPL Winner'
    // }
]

export const GAME_SUB_TYPES = 
[
    {
        id:999,
        type:'Live Casino'
    },
    {
        id:4,
        type:'Matka'
    },
    {
        id:2222,
        type:'World Casino'
    }
]


export const BET_TYPES =[
    {
        id:2,
        type:'Settle Bets'
    },
    {
        id:4,
        type:'Void'
    },
    {
        id:5,
        type:'Invalid'
    }
]


//for statements
export const REPORT_TYPES =[
    {
        id:0,
        type:'All'
    },
    {
        id:2000,
        type:'Deposit/Withdrawal'
    },
    {
        id:4,
        type:'Games'
    }
]

export const SPORTS_TYPES =[
    {
        id:'ALL',
        type:'All'
    },
    {
        id:4,
        type:'Cricket'
    },
    {
        id:1,
        type:'Soccer'
    },
    {
        id:2,
        type:'Tennis'
    }
]

//win and loss types

export const WIN_LOSS_TYPES =[
    {
        id:111,
        type:'All'
    },
    {
        id:1,
        type:'Sports'
    },
    {
        id:2,
        type:'Games'
    }
]

export const WIN_GAMES_TYPES =[
    {
        id:'ALL',
        type:'All'
    },
    {
        id:'worli',
        type:'Matka market'
    },
    {
        id:'casino',
        type:'casino'
    },
    {
        id:'sportbook',
        type:'Sportbook'
    }
]



